import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import uploader from 'vue-simple-uploader'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from './routes'
import api from './api'
import axios from 'axios';
import qs from 'qs';
import vueCookie from 'vue-cookies';
import util from './common/js/util.js'
// Mock.bootstrap();
// import 'font-awesome/css/font-awesome.min.css'
import './styles/reset.css'
import './styles/common.css'
import { Message } from 'element-ui'
// import $ from 'jquery'
import imgPreview from '@/components/imgPreview'
import './icons' // icon
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

// import './webuploader'
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(vueCookie)
Vue.use(uploader)
Vue.use(imgPreview)
// Vue.use(Viewer)
//NProgress.configure({ showSpinner: false });
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$api = api;
Vue.prototype.$util = util;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.withCredentials = true;//默认不带cookie,true为带cookie
// axios.defaults.timeout = 5000;
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
const router = new VueRouter({
  routes
})
//axios.defaults.headers['Authorization'] =sessionStorage.getItem("Authorization");
//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做某件事
    if (config.method === "post") {
      // 序列化
      config.data = qs.stringify(config.data);
      // config.data = JSON.stringify(config.data);
    }
 
    // 若是有做鉴权token , 就给头部带上token
    // 若是需要跨站点,存放到 cookie 会好一点,限制也没那么多,有些浏览环境限制了 sessionStorage 的使用
    if (sessionStorage.Authorization) {
       config.headers.Authorization = sessionStorage.Authorization;
     }
    return config;
  },
  error => {
    // error 的回调信息
    debugger
    // if(error.response.status&&error.response.status==401){
    //   Message({
    //     message: "登录超时，请从新登录！",
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   this.$router.push('login');
    // }else{
    //   Message({
    //     message: "请联系管理员！",
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    // }
    return Promise.reject(error);
  },
  
);
axios.interceptors.response.use(
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    // if (res.status !== 200) {
      // Message({
      //   message: res.message || 'error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.status === 401) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(res.message || 'error')
    // } else {
    //   return res
    // }
    //console.log("response",response)
    return response
  },
  error => {
    // console.log( 'err=====' +  error) // for debug
    // console.log(error.response.status)
    if(error.response){
      if(error.response.status&&error.response.status==401){
        Message({
          message: "登录超时，请重新登录！",
          type: 'error',
          duration: 5 * 1000
        })
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('Authorization');
        sessionStorage.removeItem('Token');
        sessionStorage.removeItem('Role');
        router.push({ path: '/login' });
      }else{
        Message({
          message: "请联系管理员！",
          type: 'error',
          duration: 5 * 1000
        })
      }
    }else{
      Message({
        message: "请联系管理员！",
        type: 'error',
        duration: 5 * 1000
      })
    }
  //   return Promise.reject(error)
   }
)


router.beforeEach((to, from, next) => {
	const userName = sessionStorage.getItem('userName');
	// console.log("userName====",userName); 
	if (!userName && !to.meta.notLogin) {//如果没有用户名，就跳转到登录页
    next('/login');
    }
    // else if(router.app.$cookies.get("status") !== "logined" && !to.meta.notLogin){//前台记住密码
    //   next('/login');
    //   Message({
    //     message: "登录超时，请重新登录！",
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    // }
    else{
      next()
    }
})

 
new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js